import React from 'react';
import classNames from 'classnames/bind';
import styles from './Provide.module.scss';

const cx = classNames.bind(styles);

function Provide_02() {
	return (
		<div className={cx('terms')}>
			<dl className={cx('dl_type1', 'mt0')}>
				<dt>제공 받은 자</dt>
				<dd>
					<em className={cx('font_bold', 'fs17')}>보증수리 제휴 정비소</em>
				</dd>
				<dt>이용목적</dt>
				<dd>
					<em className={cx('font_bold', 'fs17')}>엔카보증 가입자의 본인 확인 및 보증수리 서비스 제공</em>
				</dd>
				<dt>제공하는 항목</dt>
				<dd>(필수) 이름, 휴대전화번호, 차량번호, 결제정보</dd>
				<dt>보유 및 이용 기간</dt>
				<dd>
					<em className={cx('font_bold', 'fs17')}>보증수리 신청일로부터 1년</em>
					<br />
					단, 관계 법령에 따라 보존해야 하는 경우 관계 법령에서 정하는 기간까지 보존
				</dd>
			</dl>
			<p className={cx('pt20')}>
				*고객님께서는 위의 항목에 동의를 거부할 권리가 있습니다. 단, 동의를 거부하실 경우 엔카종합보증 서비스 이용이 제한됩니다.
			</p>
		</div>
	);
}

export default Provide_02;
